import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { storeUserMenus } from "./menus.action";

export class MenusModel{
    
    menus:any[];
   
   }
   @State<MenusModel>({
       name: 'menusmodelState',
       defaults: {
         
        menus:[]
          
        }
   })
   @Injectable()
 export class MnenusState {
 
     constructor( ) {
     }
 
     @Selector()
     static getUserMenus(state: MenusModel) {
         return state;
     }
    

     @Action(storeUserMenus)
     storeUserMenus({getState, patchState}: StateContext<MenusModel>, {payload}: storeUserMenus) {
         const state = getState();
         patchState({
              menus:payload
            });
     }
     
    } 